import { useAngularContext } from 'AngularContext';
import { type AppHeaderViewModel } from './Navigation.types';

export function useAppHeaderViewModel() {
    const injector = useAngularContext();
    const AppHeaderViewModel = injector.get<AppHeaderViewModel>('Navigation.AppHeader.AppHeaderViewModel');
    return AppHeaderViewModel;
}
